import type { FunctionComponent } from "react";

import { Container, Link } from "scmp-app/components/header/header-avatar/messages/styles";

type Props = {
  className?: string;
};
export const AppPromotionMessage: FunctionComponent<Props> = ({ className }) => {
  const appDownloadLink = "https://scmp.onelink.me/3586748601/eabf0741";
  return (
    <Container className={className}>
      <Link
        onClick={event => {
          event.preventDefault();
          window.open(appDownloadLink);
        }}
        pathname={appDownloadLink}
      >
        Download / Update
      </Link>
      {" to the new SCMP app"}
    </Container>
  );
};

AppPromotionMessage.displayName = "AppPromotionMessage";
